export const DEFAULT_FABRIC_BACKGROUND = {
  hoverCursor: 'default',
  hasBorders: false,
  hasControls: false,
  lockRotation: true,
  lockScalingX: true,
  lockScalingY: true,
  lockMovementX: true,
  lockMovementY: true
};

export const DEFAULT_LINE_HEIGHT = 1.2; // fabric default value
